import React from "react"
import clsx from "clsx"
import Layout from "components/layout"
import Breadcrumbs from "./breadcrumbs"
import PageHeader from "./page-header"
import S from "./text-page.module.scss"

type Props = {
  title: string
}

const TextPage: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  children,
  ...props
}) => {
  return (
    <Layout title={title} {...props}>
      <PageHeader title={title} />
      <Breadcrumbs current={title} />
      <section className="bg-white u-section-padding-md">
        <div className={clsx(S.container, "container")}>
          <div className="wysiwyg">{children}</div>
        </div>
      </section>
    </Layout>
  )
}

export default TextPage
